import colors, { ColorProps } from './colors';
import shadows, { ShadowProps } from './shadows';
import animations, { AnimationProps } from './animations';
import mixins from './mixins';
import fontWeights, { FontWeightProps } from './fontWeights';
import typography from './typography';
import spaces, { SpaceProps } from './spaces';
import spacingCurves, { SpacingCurveProps } from './spacingCurves';
import { layout, LayoutProp } from '../layout';

const generateResponsiveStyles = (items: any) =>
  Object.keys(items).reduce((acc: any, itemKey) => {
    acc[itemKey] = mixins.responsiveStyles(items[itemKey]);

    return acc;
  }, {});

const text = generateResponsiveStyles(typography);

const theme = {
  animations,
  colors,
  fontWeights,
  mixins,
  shadows,
  spaces,
  spacingCurves,
  text,
  layout,
};

export interface Theme {
  animations: AnimationProps;
  colors: ColorProps;
  fontWeights: FontWeightProps;
  mixins: any;
  shadows: ShadowProps;
  spaces: SpaceProps;
  spacingCurves: SpacingCurveProps;
  text: Record<string, string>;
  layout: LayoutProp[];
  campaign?: Record<string, string>;
  stylesExtension?: Record<string, any>;
}

export {
  animations,
  colors,
  fontWeights,
  mixins,
  shadows,
  spaces,
  spacingCurves,
  text,
};

export default theme;
